module.exports = __webpack_public_path__ + "static/media/like_product_3.edf236d2.svg";